<template>
<v-container fluid dense>
    <v-row justify="start">
      <v-col md="2">
        <v-card class="mx-auto"  outlined>
          <v-card-text>
            <v-text-field label="Fatture Immediate" outlined v-model="numeratoreImmediate" hint="Impostare il numero dell'ultimo documento valido" persistent-hint></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined text @click="onModifica('immediata')">Modifica</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="2">
        <v-card class="mx-auto"  outlined>
          <v-card-text>
            <v-text-field label="Fatture Differite" outlined v-model="numeratoreDifferite" hint="Impostare il numero dell'ultimo documento valido" persistent-hint></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined text @click="onModifica('differita')">Modifica</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="2">
        <v-card class="mx-auto"  outlined>
          <v-card-text>
            <v-text-field label="Documenti di Trasporto" outlined v-model="numeratoreDdt" hint="Impostare il numero dell'ultimo documento valido" persistent-hint></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined text @click="onModifica('ddt')">Modifica</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>  
    </v-row>
    <dialog-conferma
      :show="dialogConferma"
      :title="titoloConferma"
      :message="messaggioConferma"
      :confirmText="confirmText"
      :onlyOk="onlyOk"
      @dialog-confirm="onConferma"
      @dialog-cancel="dialogConferma = false; onlyOk = false; tipoModifica = ''"
    />    
  </v-container>
</template>

<script>
import DialogConferma from '@/components/dialogConferma'
import configurazioni from '@/services/configurazioniService'

export default {
  components: {
    DialogConferma
  },  
  data(vm) {
    return {
      dialogConferma: false,
      titoloConferma: '',
      messaggioConferma: '',
      confirmText: 'SI',
      onlyOk: false,
      onConferma: vm.modificaConfirm,
      numeratoreImmediate: '',
      numeratoreDifferite: '',
      numeratoreDdt: '',
      tipoModifica: ''
    }
  },
  async mounted() {
    this.numeratoreImmediate = await configurazioni.getNumeratore('immediata', false)
    this.numeratoreDifferite = await configurazioni.getNumeratore('differita', false)
    this.numeratoreDdt = await configurazioni.getNumeratore('ddt', false)
  },
  methods: {
    onModifica(tipoModifica) {
      this.tipoModifica = tipoModifica
      this.titoloConferma = 'Modifica numeratore'
      this.messaggioConferma = 'Confermi modifica numeratore ?'
      this.onConferma = this.modificaConfirm
      this.dialogConferma = true
    },    
    async modificaConfirm() {
      this.dialogConferma = false
      await configurazioni.setNumeratore(this.tipoModifica)
      let messaggio = 'Operazione eseguita con successo!'
      this.operazioneEseguita(messaggio)
    },
    operazioneEseguita(messaggio) {
      this.titoloConferma = 'Operazione eseguita'
      this.messaggioConferma = messaggio || 'Operazione eseguita con successo ! '
      this.confirmText= 'OK'
      this.onlyOk = true
      this.onConferma = this.operazioneEseguitaConfirm
      this.dialogConferma = true
    },
    operazioneEseguitaConfirm() {
      this.dialogConferma = false
      this.confirmText= 'SI'
      this.onlyOk = false
      this.tipoModifica = 0
    }    
  }
}
</script>
